<section class="admin-page-shell" [ngClass]="shellClass">
  @if (hasHeader()) {
    <app-page-header
      [title]="title"
      [description]="description"
      [icon]="icon"
      [headerClass]="headerClass"
    >
      <ng-content select="[page-meta]"></ng-content>
      <ng-content select="[page-actions]"></ng-content>
    </app-page-header>
  }

  <ng-content select="[page-toolbar]"></ng-content>
  <ng-content></ng-content>
</section>
